import React from 'react';
import { steps } from '../data/steps';
import { SectionHeading } from './ui/SectionHeading';
export function Steps() {
  return <section className="w-full bg-cream py-14 sm:py-20 lg:py-24" data-id="element-169" data-mp="18cs1b0cimb27">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-170" data-mp="un8224i57vxn">
        <SectionHeading overline="Así de simple" title={<>
              Crear una esfera hermosa puede ser{' '}
              <span className="italic text-terracotta-500" data-id="element-172" data-mp="ylxfty73ffht">
                más fácil de lo que imaginas
              </span>
            </>} data-id="element-171" data-mp="uklvo86znmh0" />

        <ol className="mt-9 grid gap-4 sm:mt-12 sm:grid-cols-3 sm:gap-6" data-id="element-173" data-mp="pon0o1r5n67m">
          {steps.map(step => <li key={step.number} className="flex flex-col overflow-hidden rounded-3xl border border-gold-200/50 bg-bone shadow-[0_22px_48px_-36px_rgba(14,35,21,0.6)] sm:rounded-4xl" data-id="element-174" data-mp="bom2wv66sewd">
              <div className="relative" data-id="element-175" data-mp="261bvn9ktji26">
                <img src={step.image} alt={step.alt} loading="lazy" className="aspect-[4/3] w-full object-cover sm:aspect-[4/5]" data-id="element-176" data-mp="262d5jaq3lyib" />
                <span className="absolute left-3.5 top-3.5 flex h-9 w-9 items-center justify-center rounded-full bg-sage-800 font-serif text-[16px] font-semibold text-gold-200 sm:left-4 sm:top-4 sm:h-10 sm:w-10 sm:text-[17px]" data-id="element-177" data-mp="2a146jsxoq0ap">
                  {step.number}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 sm:p-6" data-id="element-178" data-mp="1v22cp89bww2a">
                <h3 className="font-serif text-[1.3rem] leading-tight text-sage-800 sm:text-[1.5rem]" data-id="element-179" data-mp="1v2kh4s65agla">
                  {step.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-ink-soft sm:mt-3 sm:text-[14.5px]" data-id="element-180" data-mp="12dwqeh2mmz0c">
                  {step.body}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-9 max-w-2xl text-center font-serif text-[1.3rem] italic leading-snug text-sage-700 sm:mt-12 sm:text-[1.9rem]" data-id="element-181" data-mp="1cb1ewnjy36kb">
          “Una hora para desconectar, crear algo hermoso y disfrutar la magia de
          la Navidad.”
        </p>
      </div>
    </section>;
}